module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-001sp.3ff6bf18.jpg";